import type { FC } from "react";
import type { SessionEducationalResourceItem } from "../../interfaces/sessionDetails";
import { SessionResourceList } from "./SessionResourceList";

type SessionExamsSectionProps = {
  items: SessionEducationalResourceItem[];
};

export const SessionExamsSection: FC<SessionExamsSectionProps> = ({ items }) => (
  <SessionResourceList
    titleKey="session_exams"
    titleFallback="Exams"
    items={items}
    emptyKey="session_no_exams"
    emptyFallback="No exams for this session."
  />
);
